import _ from 'lodash'
import moment from 'moment'

import { nat } from '@/components/object_model.js'

// *****************************************************************************

// export function display_format_element(x, category, display_info) {
//   let res = undefined

//   if (category === 'float') {
//     let precision = display_info.precision
//     if (!_.isFinite(x) || !_.isFinite(precision)) {
//       res = String(x)
//     } else {
//       let multiplier = 10 ** -precision
//       let divisor = 10 ** precision
//       res = Math.floor(x * multiplier + 0.5) * divisor
//     }
//   } else if (category === 'datetime') {
//     if (moment.isMoment(x)) {
//       res = x.format(display_info.field_format)
//     } else {
//       res = x
//     }
//   } else {
//     res = x
//   }
//   return res
// }

export function display_format_element(x, category, display_info) {
  let res = undefined

  if (category === 'float') {
    let precision = display_info.precision
    if (!_.isFinite(x) || !_.isFinite(precision)) {
      if (_.isNaN(x)) {
        res = 'NA'
      } else {
        res = String(x)
      }
    } else {
      let multiplier = 10 ** -precision
      let divisor = 10 ** precision
      res = Math.floor(x * multiplier + 0.5) * divisor
    }
  } else if (category === 'datetime') {
    if (moment.isMoment(x)) {
      res = x.format(display_info.field_format)
    } else if (x === nat) {
      res = 'NA'
    } else {
      res = x
    }
  } else {
    res = x
  }
  return res
}
